export default __webpack_public_path__ + "f5779edd33ba31cfbe53f90775e11ee3.png";